import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import '../containers/App.css'
import Admin from './Admin';
import Login from '../components/login/login';
import { getUserAuthState } from '../components/api/adminAPI';


const App = () => {  
    //NEw Auth Flow --
    const [auth, setAuth] = useState({authenticated: false, user: null});

    //Runs once on mount
    useEffect(() => {    
       authHandler();
    }, []);

    //On Login Success Handler
    const authHandler = async (authState) => {  
        try {
            if(!!authState){                             
                setAuth(authState); //If Auth State is passed, Set it
            }else{
                //fetch Auth State from API
                const authRes  = await getUserAuthState();                        
                //Set Auth Set Accordingly
                if(authRes?.authenticated) setAuth(authRes);
            }
        } catch {
            return setAuth(false);
        }            
    }

    return (
        <BrowserRouter>
        {!!auth?.authenticated ? (
            <Admin auth={auth}  onAuthStateChange={authHandler} />
        ) : (
            <Switch>
                <Route path="/login" exact>
                    <Login onLogin={authHandler} />
                </Route>
                <Redirect to="/login" />
            </Switch>
        )}           
        </BrowserRouter>
    );

};

export default App;